import { RANK_BADGE_TIER_IDS } from '@/lib/ranks/rankBadgeSrc';

export function nextUnearnedTierId(
  trackId: string,
  unlockedTierIds: string[],
): string | null {
  const unlocked = new Set(unlockedTierIds);
  const prefix = `${trackId}.`;
  return RANK_BADGE_TIER_IDS.find((id) => id.startsWith(prefix) && !unlocked.has(id)) ?? null;
}
